import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import {
  customerFeedbackService,
  type UpdateCustomerFeedbackInput,
  type UpdateCustomerFeedbackResponse,
} from '@/services/feedback/CustomerFeedbackService';

export const useUpdateCustomerFeedback = (): UseMutationResult<
  UpdateCustomerFeedbackResponse,
  Error,
  UpdateCustomerFeedbackInput
> => {
  return useMutation({
    mutationFn: (input: UpdateCustomerFeedbackInput) =>
      customerFeedbackService.updateFeedback(input),
  });
};
